import { api } from "../services/Api";
import { showToast } from "../utils";

export function useContestation() {
  const baseUrl = '/charges'
  async function getInitialData(search?: string) {
    if (search === "") {
      return await api.get(`${baseUrl}/dispute`, {})
    }
    else {
      try {
        return await api.get(`${baseUrl}/dispute?sellerName=${search}`, {})
      } catch (error) {
        showToast({
          type: "error",
          message: "Falha ao c"
        })
      }

    }
  }
  const putDisputeCharge = async (id: string, disputeChargeData: any) => {
    return await api.put(`${baseUrl}/dispute/${id}`, disputeChargeData);
  }
  const putChargeStatus = async (chargeStatusData: any) => {
    return await api.put(`${baseUrl}/update-status`, chargeStatusData);
  }


  return {
    getInitialData,
    putDisputeCharge,
    putChargeStatus
  }
}